import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEinwertIconDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 131 131",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#08124A",
			d: "M0 0h131v131H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m82.627 41.515-8.955 30.887-5.781 16.242h11.912l15.049-47.13zm-28.727 0-8.07 30.887-8.783-30.887H25l14.827 47.129h12.047l4.691-17.906.618-2.356 2.633-10.047 4.341-16.698z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M92.327 89.485V76.163L101 70.97l9 5.193v13.322z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m55.297 41.637 4.204 16.698 2.55 10.047.599 2.356 4.544 17.906H78.86l-5.813-16.242-7.817-30.887z",
			opacity: .7
		})
	]
});
export default SvgEinwertIconDark;
